var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.overlay)?_c('div',{staticClass:"overlay-loader"}):_vm._e(),(_vm.loader)?_c('div',{style:(_vm.loaderStyle),attrs:{"id":"loader"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }